"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_2_target = _interopRequireDefault(require("../images/help_2_target.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var targetBar = {
  id: "targetBar",
  title: {
    en: "Target Bar",
    de: "Ziel-Leiste"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_2_target.default,
      alt: "",
      style: {
        width: "226px",
        height: "36px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Target Bar"), /*#__PURE__*/_react.default.createElement("p", null, "When you left click a target, in the middle of the window screen, you can view the character's HP, name, and battle difficulty."), /*#__PURE__*/_react.default.createElement("p", null, "In the difficulty there are 7 columns, 4 is the average and as you move toward the left they become easier, and as you move toward the right they will be more difficult."), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#0F4079"
      }
    }, "@OOOOOO"), "Very easy opponents: They are easy to hunt, but you may get very little experience points and items.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#0FAEA3"
      }
    }, "O@OOOOO"), "Little bit easier opponents: Little experience points and low grade items and low chance of getting an item.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#B2D67C"
      }
    }, "OO@OOOO"), "Easy opponent: Easy to hunt, average chance to get an item and experience points.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "OOO@OOO"), "Normal opponents: At times it may be difficult, but in pretty decent amount of experience points and items are decent.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "OOOO@OO"), "Stronger opponents: You can hunt alone, but there are risks of getting into trouble.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FF530F"
      }
    }, "OOOOO@O"), "Difficult opponents: They are difficult to hunt alone, but they are good for a group hunt.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#D41111"
      }
    }, "OOOOOO@"), "Very difficult opponents: They are even difficult for a party to hunt."))), /*#__PURE__*/_react.default.createElement("p", null, "During play the difficulty bar along with type of class, race and experience in party game will determined the damage."), /*#__PURE__*/_react.default.createElement("p", null, "There are ways to target other than the mouse, using F6 will automatically target nearest NPC, F7 will target nearest PC, F8 targets nearest NPC or PC, F9 self target will help you to play quick and easy."))
  }
};
var _default = targetBar;
exports.default = _default;